import TableContainer from './TableContainer';

export default TableContainer;
